/**
 * Resolve the correct answer for a phishing_quiz activity to a canonical
 * 'phishing' | 'legitimate' string.
 *
 * The answer is stored differently depending on where the activity came from:
 *   - Question bank items store it as `correct_answer` string ('phishing' /
 *     'legitimate') alongside `options: ['phishing', 'legitimate']`.
 *   - The activity editor's radio stores `type` ('phishing' / 'legitimate')
 *     plus a numeric `correct_answer` index (0 = phishing, 1 = legitimate).
 *
 * Reading a single field misses one of these origins, so both the player and
 * the presenter view must resolve through here.
 */
export function resolvePhishingAnswer(
  data: Record<string, any> | null | undefined
): 'phishing' | 'legitimate' | null {
  if (!data) return null

  if (data.type === 'phishing' || data.type === 'legitimate') return data.type

  const ca = data.correct_answer
  if (ca === 'phishing' || ca === 'legitimate') return ca

  // Numeric index into the answer options.
  if (typeof ca === 'number') {
    const opt = Array.isArray(data.options) ? data.options[ca] : undefined
    if (opt === 'phishing' || opt === 'legitimate') return opt
    if (ca === 0) return 'phishing'
    if (ca === 1) return 'legitimate'
  }

  return null
}
